import React from 'react'

const WebsitePage = () =>{
	return (
		<div className='container'>
			<h4 className=''>WebsitePage</h4>
			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque pulvinar scelerisque magna sodales ultrices. Morbi sodales viverra felis et interdum. Pellentesque a rutrum purus. Etiam mattis est et nisl vehicula bibendum ac a nisi. Donec ultricies tellus at felis ultricies hendrerit. Aliquam in arcu fermentum, egestas dolor sed, venenatis felis. Donec at dui eu augue sodales ornare. Maecenas luctus imperdiet ligula nec egestas. Nam eget cursus lectus, ac maximus lacus. Vestibulum gravida tincidunt molestie. Quisque luctus et odio at tincidunt. Quisque ac nisl vitae risus ornare scelerisque eu quis est. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id tortor quis ligula vehicula iaculis ut non nisl. Sed vehicula tortor id euismod tincidunt.</p>
		</div>
		);
}

export default WebsitePage